import { BillToCompanyMappingEntity, EMPTY_BILL_TO_COMPANY_MAPPING_ENTITY } from "domain/entity/BillToCompanyMapping/BillToCompanyMappingEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";


export interface BillToCompanyMappingDropdownOptions {
    chargeTypeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
    operatingTmlDropdownOptions: DropdownProps[],
    serviceCodeDropdownOptions: DropdownProps[],
    soaDropdownOptions: DropdownProps[],
    opsLineDropdownOptions: DropdownProps[],
    billToCompanyDropdownOptions: DropdownProps[],
    vesselTypeDropdownOptions: DropdownProps[],
    consortiumCodeDropdownOptions: DropdownProps[],
    forwarderCodeDropdownOptions: DropdownProps[],
    chargeCodeDropdownOptions: DropdownProps[],
    // opsLineCompanyDropdownOptions: DropdownProps[],
}
export interface BillToCompanyMappingViewChangeState extends BaseViewChangeSate {
}

export interface BillToCompanyMappingModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    dynamicOptions: BillToCompanyMappingDropdownOptions,
    billToCompanyMappingList: BillToCompanyMappingEntity[],
    selectedRows: BillToCompanyMappingEntity[],
    updatedRows: BillToCompanyMappingEntity[],
    currentRow: BillToCompanyMappingEntity,
    currentEditRow: BillToCompanyMappingEntity,
    forceRefresh: boolean,
    masterState: BillToCompanyMappingViewChangeState,
}

export const EMPTY_BILL_TO_COMPANY_MAPPING_MODEL: BillToCompanyMappingModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    dynamicOptions: {
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {},
        operatingTmlDropdownOptions: [],
        serviceCodeDropdownOptions: [],
        soaDropdownOptions: [],
        opsLineDropdownOptions: [],
        billToCompanyDropdownOptions: [],
        vesselTypeDropdownOptions: [],
        consortiumCodeDropdownOptions: [],
        forwarderCodeDropdownOptions: [],
        chargeCodeDropdownOptions: [],
        // opsLineCompanyDropdownOptions: [],
    },
    billToCompanyMappingList: [],
    selectedRows: [],
    updatedRows: [],
    currentRow: { ...EMPTY_BILL_TO_COMPANY_MAPPING_ENTITY },
    currentEditRow: { ...EMPTY_BILL_TO_COMPANY_MAPPING_ENTITY },
    forceRefresh: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}